// extracted by mini-css-extract-plugin
export default {"colocationColor":"#aa0061","developmentColor":"#e4002b","enterpriseColor":"#6e4180","userAvatar":"ZgXhWA3E5gKxgTV7INQd","circle":"otOPVRvYWLFHjqU08H6J"};